import React from 'react';
import { View } from 'react-native';

import { RectangleLoader } from '../../../Components/Loader';
import ListItemLoader from '../../../Components/ListItemLoader';
import themeStyle from '../../../Theme/styles';

import { ids, styles } from './EventItem';

const EventItemLoader = () => {
  return (
    <View dataSet={{ media: ids.wrapper }} style={styles.wrapper}>
      <View dataSet={{ media: ids.firstColumn }} style={styles.firstColumn}>
        {/* Reservation Type */}
        <View
          style={[themeStyle.alignItemsStart, themeStyle.spacingBottomMedium]}
        >
          <RectangleLoader width={100} height={35.5} />
        </View>
        {/* Event Name */}
        <View style={themeStyle.spacingBottomMedium}>
          <RectangleLoader height={39} />
        </View>
        {/* Event Description */}
        <View style={themeStyle.spacingBottom}>
          <RectangleLoader height={51} />
        </View>
        {/* Date */}
        <View style={{ width: '90%' }}>
          <ListItemLoader
            contentContainerStyle={themeStyle.spacingBottomSmall}
            textSize={25.5}
            withLeftIcon
          />
        </View>
        {/* Time */}
        <View style={{ width: '75%' }}>
          <ListItemLoader
            contentContainerStyle={themeStyle.spacingBottomSmall}
            textSize={25.5}
            withLeftIcon
          />
        </View>
        {/* Price */}
        <View style={{ width: '65%' }}>
          <ListItemLoader
            contentContainerStyle={themeStyle.spacingBottom}
            textSize={25.5}
            withLeftIcon
          />
        </View>
        {/* Button */}
        <View style={[themeStyle.flex1, themeStyle.flexDirectionRowCenter]}>
          <View style={{ borderRadius: 150, overflow: 'hidden' }}>
            <RectangleLoader width={166} height={51} />
          </View>
        </View>
      </View>
      {/* Image */}
      <View dataSet={{ media: ids.secondColumn }} style={styles.secondColumn}>
        <View style={styles.image}>
          <RectangleLoader height="100%" />
        </View>
      </View>
    </View>
  );
};

export default EventItemLoader;
